<template>
  <body>
  <cursor-fx ref="cursor" color="#6b4000" color-hover="#fa9732" inside-size="15px" outside-size="90px"></cursor-fx>
  <div class="all_box">
    <div class="apply_btn_box">
      <router-link to="ApplicationForm"><btn class="apply_btn"  data-cursor-hover>
        応募する
      </btn></router-link>
    </div>
    <div class="cb" />
    <div class="title_box jp_font">
      <div>
        <div class="title_h1 en_font">REQUIREMENTS</div>
        <div class="title_h2 jp_font">募集概要 ー フロントセールス</div>
      </div>
    </div>
    <div />
    <div class="Requirements_Engineer_box ">
      <!-- <img class="Requirements_Engineer_img" v-lazy="require('@/assets/bosyu_422A9517_2048px.jpg')" /> -->
      <div class="Requirements_Engineer_smallbox">
        <p class="Requirements_Engineer_subtitle">仕事概要</p>
        <p class="Requirements_Engineer_text">エンジニアリングサービスを軸に、システム設計構築や開発などの受託営業、BPO推進の営業を行い、事業拡大を推進して頂きます。
        </p>
        <p class="Requirements_Engineer_text">お客様のプロジェクトについてヒアリングし、スキルに応じたエンジニアを提案します。<br/>
                                              顧客企業とエンジニアをマッチングする役割を持ち、エンジニアの提案、面談などを通じて契約を獲得して頂きます。
        </p>
        <p class="Requirements_Engineer_text">お客様とプロジェクトに参画しているエンジニアに状況のヒアリングを実施し、適宜、常駐業務やアウトソーシングやシステム受託の提案をしていきます。
        </p>
        <p class="Requirements_Engineer_text">新規取引のお客様、既存取引のお客様に対する営業活動を行いながら、ニーズに合わせたサービスの提案/企画などを行います。
        </p>
        <div style="padding-top:30px;" />
        <p class="Requirements_Engineer_subtitle">必須スキル</p>
        <ul class="Requirements_Engineer_text">
          <li>従業員に対し常に前向きで明るい対応ができ、チームメンバー同士協力し合いながら仕事ができること</li>
          <li>IT関係での実務経験</li>
          <span>※エンジニア、営業など職種不問（未経験の方も応相談）</span>
        </ul>
        <div style="padding-top:30px;" />
        <p class="Requirements_Engineer_subtitle">歓迎スキル</p>
        <ul class="Requirements_Engineer_text">
          <li>法人向け提案型営業の経験</li>
          <li>新規顧客開拓経験</li>
        </ul>
        <div style="padding-top:30px;" />
        <p class="Requirements_Engineer_subtitle">求める人物像</p>
        <ul class="Requirements_Engineer_text">
          <li>役職に関係なくリーダーシップとスキルを発揮し、バリュー(成果、付加価値)を出すことに集中できる方</li>
          <li>論理的な思考を持ち、適切な質疑応答等のコミュニケーションができる方</li>
          <li>クライアント/エンジニアなど周囲の人間と信頼関係を構築できる方</li>
        </ul>
        <div style="padding-top:30px;" />
        <p class="Requirements_Engineer_subtitle">応募概要</p>
        
        <table class="Requirements_Engineer_table">
          <tr>
            <th>給与</th>
            <td>400万円  ～  900万円</td>
          </tr>
          <tr>
            <th>勤務地</th>
            <td>〒140-0013<br />
                東京都品川区南大井 6-22-7 大森ベルポートE館2階<br />
                <span>※顧客によって変更となる可能性があります</span>    
            </td>
          </tr>
          <tr>
            <th>勤務体系</th>
            <td>■勤務時間<br />
                9:00 ～ 18:00（休憩 12:00 ～13:00）<br />
                <span>※顧客によって変更となる可能性があります</span><br /><br />
                ■年間休日数<br />
                120 日以上
            </td>
          </tr>
          <tr class="Requirements_Engineer_last">
            <th>福利厚生</th>
            <td ><ul>
                  <li>有給休暇は入社翌月から16日付与</li>
                  <li>賞与年２回 （2023 年度実績：平均年6.8ヶ月分）</li>
                  <li>住宅手当:<br>
                      配偶者ありの場合(40歳まで)：家賃の半額(上限6万円)<br>
                      配偶者なしの場合(34歳まで)：家賃の半額(上限3万円)
                  </li>
                  <li>関東ITソフトウェア健康保険組合加入</li>
                  <li>家族手当（扶養家族１人につき月１万円）</li>
                  <li>残業月平均17時間</li>
                  <li>リモートワークや時差出勤あり</li>
                  <li>フレックス制（コアタイムなし）</li>
                  <li>お茶、お水、コーヒーなどを無料で飲めるオフィス内フリードリンク制度あり</li>
                </ul>
            </td>
          </tr>
        </table>
 
        <div style="padding-top:30px;" />
        <p class="Requirements_Engineer_subtitle">企業情報</p>

        <table class="Requirements_Engineer_table">
          <tr>
            <th>企業名</th>
            <td>株式会社HES</td>
          </tr>
          <tr>
            <th>設立年月日</th>
            <td>2019年 （令和元年）7 月 10 日
            </td>
          </tr>
          <tr>
            <th>本社所在地</th>
            <td>〒140-0013<br />
              東京都品川区南大井 6-22-7 大森ベルポートE館2階<br /> 
            </td>
          </tr>
          <tr>
            <th>資本金</th>
            <td>3,000万円
            </td>
          </tr>
          <tr class="Requirements_Engineer_last">
            <th>従業員数</th>
            <td>108 名（2026/3/1時点）<br />
                平均年齢 / 36 歳<br />
                男女比 / 男性 80名、女性 18名<br />
                <!--中途入社の割合 / 100％-->
            </td>
          </tr>
        </table>
        <div style="padding-top:30px;" />
      
      </div>
    </div>
    <div class="Requirements_Engineer_endbox"/>
    <div class="Requirements_Engineer_Application_box">
      <div class="Requirements_Engineer_Application_smallbox">
        <p class="Requirements_Engineer_Application_subtitle">応募について</p>
        <p class="Requirements_Engineer_Application_text">選考プロセスは下記のとおりです。<br />まずはカジュアル面談をしてみて選考に進むか検討したいという方もお気軽にご応募ください。</p>
      
        <div style="padding-top:30px;" />
        <div class="Requirements_Engineer_Application_flex">
          <div class="Requirements_Engineer_Application_flex_item">
            <p class="Requirements_Engineer_Application_circle">
              <span>
                <div class="Requirements_Engineer_Application_STEP">STEP</div>
                <div class="Requirements_Engineer_Application_NUM">01</div>
              </span>
              <span class="Requirements_Engineer_Application_step_text">
                応募
              </span>
            </p>
            <p class="Requirements_Engineer_Application_circle">
              <span>
                <div class="Requirements_Engineer_Application_STEP">STEP</div>
                <div class="Requirements_Engineer_Application_NUM">02</div>
              </span>
              <span class="Requirements_Engineer_Application_step_text">
                書類選考
              </span>
            </p>
            <p class="Requirements_Engineer_Application_circle">
              <span>
                <div class="Requirements_Engineer_Application_STEP">STEP</div>
                <div class="Requirements_Engineer_Application_NUM">03</div>
              </span>
              <span class="Requirements_Engineer_Application_step_text">
                WEB面接（現場社員）
              </span>
            </p>
            <p class="Requirements_Engineer_Application_circle">
              <span>
                <div class="Requirements_Engineer_Application_STEP">STEP</div>
                <div class="Requirements_Engineer_Application_NUM">04</div>
              </span>
              <span class="Requirements_Engineer_Application_step_text">
                対面面接（社長・シニアエンジニア）
              </span>
            </p>
          </div>
          <div class="Requirements_Engineer_Application_flex_item">
            <p class="Requirements_Engineer_Application_subbox">  
                                                                  ◆選考について<br/>
                                                                  ※応募の秘密厳守します<br/>
                                                                  ※応募書類はご返却できませんので、予めご了承ください<br/>
                                                                  ※ご応募から内定までは3～4週間を予定しております<br/>
                                                                  ※面接日、入社日はご相談に応じます<br/>
                                                                  ※結果については合否に関わらずご連絡いたします<br/>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
  </body>
</template>


<style>
@import "../../css/Portal_base_engineer.css";
</style>

<script>
export default {
  jsonld: {
    "@context": "http://schema.org",
    "@type": "JobPosting",
    "datePosted": "2025-05-13",
    "validThrough": "2030-03-31",
    "employmentType": "FULL_TIME",
    "title": "営業",
    "description": "大森駅に本社があるIT企業です。エンジニアリングサービスを軸に、システム設計構築や開発などの受託営業、BPO推進の営業を行い、事業拡大を推進して頂きます。",
    "hiringOrganization": {
      "@type": "Organization",
      "name": "株式会社HES",
      "logo": "https://recruit.he-service.co.jp/static/img/recruit_logo.png"
    },
    "jobLocation": {
      "@type": "Place",
      "address": {
        "@type": "PostalAddress",
        "postalCode": "140-0013",
        "streetAddress": "南大井 6-22-7 大森ベルポートE館2階",
        "addressLocality": "品川区",
        "addressRegion": "東京都",
        "addressCountry": "JP",
      }
    },
    "baseSalary": {
      "@type": "MonetaryAmount",
      "currency": "JPY",
      "value": {
        "@type": "QuantitativeValue",
        "minValue": 4000000,
        "maxValue": 9000000,
        "unitText": "YEAR"
      }
    }
  },
  methods: {
    router_ApplicationForm(){
      const next = 'auth/ApplicationForm';
      this.$router.push({name:next}).catch(() => {});
    },
  }
}
</script>
